<template>
  <div v-if="!item.hidden">
    <template
      v-if="hasOneShowingChild(item.children, item) && (!onlyOneChild.children || onlyOneChild.noShowingChildren) && !item.alwaysShow">
      <router-link v-if="onlyOneChild.meta" :to="resolvePath(onlyOneChild.path, onlyOneChild.query)">
        <el-menu-item :index="resolvePath(onlyOneChild.path)" :class="{ 'submenu-title-noDropdown': !isNest }">
          <svg-icon v-if="item.meta.icon" :icon-class="item.meta.icon"
            style="font-size: 16px;vertical-align: middle;" />
          <el-badge :value="item.badgeValue" :max="99" is-dot :hidden="!item.badgeValue" class="badge-item">
            <span>{{ item.meta.title }}</span>
          </el-badge>
        </el-menu-item>
      </router-link>
    </template>

    <el-submenu v-else ref="subMenu" :index="resolvePath(item.path)" popper-append-to-body>
      <template slot="title">
        <svg-icon v-if="item.meta.icon" :icon-class="item.meta.icon" style="font-size: 16px;vertical-align: middle;" />
        <el-badge is-dot :hidden="badgeHidden(item.children)" class="badge-item-dot">
          <span>{{ item.meta.title }}</span>
        </el-badge>
      </template>
      <sidebar-item v-for="child in item.children" :key="child.path" :is-nest="true" :item="child"
        :base-path="resolvePath(child.path)" class="nest-menu" />
    </el-submenu>
  </div>
</template>

<script>

export default {
  name: 'SidebarItem',
  props: {
    // route object
    item: {
      type: Object,
      required: true
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ''
    }
  },
  data() {
    this.onlyOneChild = null
    return {}
  },
  methods: {
    badgeHidden(children) {
      if (children) {
        const flag = children.some(item => item.badgeValue)
        return !flag
      }
      return true
    },
    hasOneShowingChild(children = [], parent) {
      if (!children) {
        children = []
      }
      const showingChildren = children.filter(item => {
        if (item.hidden) {
          return false
        } else {
          // Temp set(will be used if only has one showing child)
          this.onlyOneChild = item
          return true
        }
      })

      // When there is only one child router, the child router is displayed by default
      if (showingChildren.length === 1) {
        return true
      }

      // Show parent if there are no child router to display
      if (showingChildren.length === 0) {
        this.onlyOneChild = { ...parent, path: '', noShowingChildren: true }
        return true
      }

      return false
    },
    isExternal(path) {
      return /^(https?:|mailto:|tel:)/.test(path)
    },
    getNormalPath(p) {
      if (p.length === 0 || !p || p == 'undefined') {
        return p
      }
      let res = p.replace('//', '/')
      if (res[res.length - 1] === '/') {
        return res.slice(0, res.length - 1)
      }
      return res;
    },
    resolvePath(routePath, routeQuery) {
      if (this.isExternal(routePath)) {
        return routePath
      }
      if (this.isExternal(this.basePath)) {
        return this.basePath
      }

      if (routeQuery) {
        let query = JSON.parse(routeQuery);
        return { path: this.getNormalPath(this.basePath + '/' + routePath), query: query }
      }
      return this.getNormalPath(this.basePath + '/' + routePath)
    }
    // 是否展示item
    // right(router) {
    //   // meta存在hideMenu且true的状态隐藏菜单 配置：baseSetManager/menuManager页面
    //   // 二级child不展示菜单入口 所有二级以后child，在前端增加itemHide字段。详见：store->user->function resetMenus()
    //   // 增加showMenuIds强制显示下一级菜单
    //   if ((router.meta && router.meta.hideMenu) || router.itemHide) {
    //     // 判断顶级id是否包含
    //     if (router.meta.showMenuOrigIds && (router.meta.showMenuOrigIds.split(',').find(item => Number(item) === this.userData.orgId))) {
    //       return true
    //     } else if (router.meta.showMenuIds && (router.meta.showMenuIds.split(',').find(item => Number(item) === this.userData.deptId))) {
    //       // 隐藏菜单后指定商户可以查看
    //       return true
    //     } else {
    //       return false
    //     }
    //   } else {
    //     return true
    //   }
    // },
    // 是否展示child
    // showChild(router) {
    //   // 二级child不展示菜单入口 所有二级以后child，在前端增加childrenHide字段。详见：store->user->function resetMenus()
    //   if (router.childrenHide) {
    //     return false
    //   }
    // }
  }
}
</script>

<style lang="scss" scoped>
.badge-item-dot {
  ::v-deep .el-badge__content.is-fixed {
    top: 50%;
    right: -8px;
    transform: translateY(-105%);
    line-height: 16px;
  }
}

.badge-item {
  ::v-deep .el-badge__content.is-fixed {
    top: 50%;
    right: unset;
    line-height: 16px;
  }
}
</style>
